module.exports = __webpack_public_path__ + "img/section_nescafe_gold.0d165b8b.png";